import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/inventories/sales-comparison", { params });
};

const salesComparisonService = {
  getAll
};

export default salesComparisonService;